import { render, staticRenderFns } from "./FichajeAdmin.vue?vue&type=template&id=ab4ebc76&"
import script from "./FichajeAdmin.vue?vue&type=script&lang=js&"
export * from "./FichajeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FichajeAdmin.vue?vue&type=style&index=0&id=ab4ebc76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports